import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { Address } from '@lukso/controllerapps-sharedlogic-primitives'

const ToPropsSchema = z.object({
  toValue: z.instanceof(Address),
})

type ToProps = z.infer<typeof ToPropsSchema>

export class To extends ValueObject<ToProps> {
  /**
   * @returns A 0x-prefixed checksum-based hex string of the to address.
   */
  public getChecksumValue(): string {
    return this.props.toValue.getChecksumValue()
  }

  public static create(toValue: Address): To {
    const validatedProps = ToPropsSchema.parse({ toValue })
    return new To(validatedProps)
  }
}
